import { keyBy } from 'lodash';
import { defaultPaginationConfig } from '../../constants/config-defaults';
import { unreachable, isOfType, isDefined } from '../../../ts-utils';
import { getCommentListIds } from './top-level-comments/top-level-comment-selectors';
import { getReplyListState } from './replies/replies-selectors';
import { getNextChunkState, getPrevChunkState } from './paging/comments-paging-selectors';
import { getRatingsState } from './ratings/ratings-selectors';
export const getResourceCommentsState = (state) => {
    if (!state) {
        return {
            type: 'PENDING',
            ordering: defaultPaginationConfig.ordering,
        };
    }
    switch (state.type) {
        case 'PENDING': {
            return {
                type: 'PENDING',
                ordering: state.configs.pagination.ordering,
                lastTotals: state.lastTotals,
            };
        }
        case 'ERROR': {
            return {
                type: 'ERROR',
                error: state.error,
                subType: state.subType,
            };
        }
        case 'READY': {
            return mapReadyState(state);
        }
        default: {
            throw unreachable(state);
        }
    }
};
const mapReadyState = (state) => {
    const commentListIds = getCommentListIds(state.topLevelCommentList, state.commentsById);
    const commentList = commentListIds.map((id) => state.commentsById[id]);
    const replies = keyBy(commentListIds
        .map((id) => getReplyListState(state.replyLists[id], state.commentsById))
        .filter(isDefined), (replyListState) => replyListState.parentCommentId);
    return {
        type: 'READY',
        commentList,
        next: getNextChunkState(state),
        prev: getPrevChunkState(state),
        ordering: state.configs.pagination.ordering,
        totals: state.totals,
        isEmpty: commentList.length === 0 && state.topLevelCommentList.liveCommentsPurgatory.length === 0,
        replies,
        permissions: state.configs.permissions,
        scrollAnchor: state.effects?.scrollAnchor,
        highlight: state.effects?.highlight,
        ratings: getRatingsState(state.ratings),
        commentBox: state.effects?.commentBox,
        showLiveCommentsButton: state.topLevelCommentList.liveCommentsPurgatory.length > 0
            ? { type: 'VISIBLE', count: state.topLevelCommentList.liveCommentsPurgatory.length }
            : { type: 'HIDDEN' },
        someoneIsTyping: state.effects?.someoneIsTyping || 'none',
    };
};
export const getCommentStateById = (state, resourceId) => (commentId) => {
    const resourceState = state.comments[resourceId];
    if (resourceState?.type !== 'READY') {
        return undefined;
    }
    return resourceState.commentsById[commentId];
};
export const getCommentById = (state, resourceId) => (commentId) => {
    const comment = getCommentStateById(state, resourceId)(commentId);
    if (comment && isOfType(['COMMENT_READY', 'REPLY_READY'], comment)) {
        return comment.comment;
    }
};
export const getToast = (state, resourceId) => {
    const resourceState = state.comments[resourceId];
    if (resourceState?.type !== 'READY') {
        return undefined;
    }
    return resourceState.effects?.toast;
};
//# sourceMappingURL=comments-selectors.js.map